module.exports = __webpack_public_path__ + "img/free.b7fdebf8.jpg";